const setValue = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};
const clear = (key) => localStorage.removeItem(key);
const get = (key) => localStorage.getItem(key);

export const setLocalUser = (user) => {
  let userNew = {
    ...user,
    name: user.firstName + " " + user.lastName,
    image: user.photoURL,
  };
  setValue("user", userNew);
};

export const getLocalUser = () => {
  const userString = get("user");

  try {
    return JSON.parse(userString);
  } catch {
    clear("user");
    return null;
  }
};

export const clearLocalUser = () => {
  clear("user");
};
